"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Prefixes {
    static AdminScope = 'a.'; // Administrative permissions (for example: ADMIN_Marketing_Edit)
    static BaseScope = 'b.'; // Base permissions that apply within one's own organization
    static CrossOrgScope = 'c.'; // Permissions that apply to orgs other than one's own
}
exports.default = Prefixes;
